export const ordersActionType = {
  loadOrders: "loadOrders",
  SET_LOADING: "SET_LOADING",
  SET_STATUS: "SET_STATUS",
};
